// extracted by mini-css-extract-plugin
export default {"wrapper":"d7kFiH_9IJDE8QUp005h"};